import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IChangeFormState = {
    isLoading: false,
    hiddenByRulesFields: [],
    hiddenFields: [],
    fields: [],
    rules: [],
    imsValues: {},
    limitsSettings: {},
    limitsCurrency: ''
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.TChangeFormAction): Types.IChangeFormState | void => {
        switch (action.type) {
            case actionTypes.SET_FORM_FIELDS_AND_RULES:
            case (actionTypes.SET_FORM_FIELDS_AND_RULES + reducerSuffix) as actionTypes.SET_FORM_FIELDS_AND_RULES: {
                Object.assign(draftState, {
                    fields: action.payload.formFields,
                    rules: action.payload.formRules
                });

                break;
            }
            case actionTypes.TOGGLE_LOADING:
            case (actionTypes.TOGGLE_LOADING + reducerSuffix) as actionTypes.TOGGLE_LOADING: {
                Object.assign(draftState, {
                    isLoading: action.payload
                });

                break;
            }
            case actionTypes.SET_HIDDEN_BY_RULES_FIELDS:
            case actionTypes.SET_HIDDEN_BY_RULES_FIELDS + reducerSuffix as actionTypes.SET_HIDDEN_BY_RULES_FIELDS: {
                Object.assign(draftState, {
                    hiddenByRulesFields: action.payload
                });

                break;
            }

            case actionTypes.ADD_HIDDEN_FIELD:
            case actionTypes.ADD_HIDDEN_FIELD + reducerSuffix: {
                Object.assign(draftState, {
                    hiddenFields: [...new Set([...draftState.hiddenFields, action.payload])]
                });

                break;
            }
            case actionTypes.REMOVE_HIDDEN_FIELD:
            case actionTypes.REMOVE_HIDDEN_FIELD + reducerSuffix as actionTypes.REMOVE_HIDDEN_FIELD: {
                Object.assign(draftState, {
                    hiddenFields: draftState.hiddenFields.filter(field => field !== action.payload)
                });

                break;
            }
            case actionTypes.SET_FORM_INTERNAL_ERROR:
            case actionTypes.SET_FORM_INTERNAL_ERROR + reducerSuffix as actionTypes.SET_FORM_INTERNAL_ERROR: {
                Object.assign(draftState, {
                    formInternalError: action.payload
                });

                break;
            }

            case actionTypes.SET_LIMITS_CURRENCY:
            case actionTypes.SET_LIMITS_CURRENCY + reducerSuffix as actionTypes.SET_LIMITS_CURRENCY: {
                Object.assign(draftState, {
                    limitsCurrency: action.payload
                });

                break;
            }

            case actionTypes.SET_LIMITS_SETTINGS:
            case actionTypes.SET_LIMITS_SETTINGS + reducerSuffix as actionTypes.SET_LIMITS_SETTINGS: {
                const { type, settings } = action.payload;

                Object.assign(draftState, {
                    limitsSettings: {
                        ...draftState.limitsSettings,
                        [type]: settings
                    }
                });

                break;
            }

            case actionTypes.UPDATE_IMS_VALUES:
            case actionTypes.UPDATE_IMS_VALUES + reducerSuffix as actionTypes.UPDATE_IMS_VALUES: {
                draftState.imsValues = action.payload;

                break;
            }

            default: {
                break;
            }
        }
    }, defaultState);
